var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1211 12.0002L23.5608 2.56162C24.1467 1.97566 24.1467 1.02564 23.5608 0.439722C22.9748 -0.146238 22.0248 -0.146238 21.4389 0.439722L12.0002 9.8793L2.56161 0.439722C1.97565 -0.146238 1.02563 -0.146238 0.439714 0.439722C-0.146199 1.02568 -0.146246 1.97571 0.439714 2.56162L9.8793 12.0002L0.439714 21.4389C-0.146246 22.0248 -0.146246 22.9748 0.439714 23.5608C1.02567 24.1467 1.9757 24.1467 2.56161 23.5608L12.0002 14.1211L21.4388 23.5608C22.0248 24.1467 22.9748 24.1467 23.5607 23.5608C24.1467 22.9748 24.1467 22.0248 23.5607 21.4389L14.1211 12.0002Z",
    fill: "#7266ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPurple);
export default __webpack_public_path__ + "static/media/crossPurple.bcd5008ff2825a9d9920cdf494b9fb38.svg";
export { ForwardRef as ReactComponent };